/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Leakeddatatitle2Inputs */

const id_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyangkalan Data Bocor:`)
};

const ms_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penafian Data Bocor:`)
};

const da_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarsfraskrivelse for Lækkede Data:`)
};

const de_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haftungsausschluss für durchgesickerte Daten:`)
};

const en_us2_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leaked Data Disclaimer:`)
};

const es_es2_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso sobre datos filtrados:`)
};

const es_mx2_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso sobre datos filtrados:`)
};

const fil_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disclaimer sa Na-leak na Data:`)
};

const fr_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avertissement concernant les données divulguées :`)
};

const it_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disclaimer sui dati trapelati:`)
};

const hu_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogi nyilatkozat a kiszivárgott adatokról:`)
};

const nl_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrijwaring gelekt gegevens:`)
};

const no_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarsfraskrivelse for lekkede data:`)
};

const pl_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastrzeżenie dotyczące wyciekłych danych:`)
};

const pt_br2_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isenção de responsabilidade de dados vazados:`)
};

const pt_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso sobre dados divulgados:`)
};

const ro_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declinarea responsabilității pentru date scurse:`)
};

const fi_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietovuotoja koskeva vastuuvapauslauseke:`)
};

const sv_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarsfriskrivning för läckta data:`)
};

const vi_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuyên bố miễn trừ về dữ liệu bị rò rỉ:`)
};

const tr_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sızdırılan Veri Sorumluluk Reddi:`)
};

const cs_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlášení o uniklých datech:`)
};

const bg_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказ от отговорност за изтекли данни:`)
};

const ru_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказ от ответственности за утечку данных:`)
};

const uk_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застереження щодо витоку даних:`)
};

const ar_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إخلاء مسؤولية البيانات المسربة:`)
};

const hi_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लीक डेटा अस्वीकरण:`)
};

const th_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อจำกัดความรับผิดชอบเกี่ยวกับข้อมูลรั่วไหล:`)
};

const ja_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リークデータに関する免責事項：`)
};

const zh_cn2_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`泄露数据免责声明：`)
};

const zh_hant1_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`洩漏資料免責宣告：`)
};

const ko_about_leakeddatatitle2 = /** @type {(inputs: About_Leakeddatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유출 데이터 면책 조항:`)
};

/**
* | output |
* | --- |
* | "Leaked Data Disclaimer:" |
*
* @param {About_Leakeddatatitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_leakeddatatitle2 = /** @type {((inputs?: About_Leakeddatatitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Leakeddatatitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_leakeddatatitle2(inputs)
	if (locale === "ms") return ms_about_leakeddatatitle2(inputs)
	if (locale === "da") return da_about_leakeddatatitle2(inputs)
	if (locale === "de") return de_about_leakeddatatitle2(inputs)
	if (locale === "en-US") return en_us2_about_leakeddatatitle2(inputs)
	if (locale === "es-ES") return es_es2_about_leakeddatatitle2(inputs)
	if (locale === "es-MX") return es_mx2_about_leakeddatatitle2(inputs)
	if (locale === "fil") return fil_about_leakeddatatitle2(inputs)
	if (locale === "fr") return fr_about_leakeddatatitle2(inputs)
	if (locale === "it") return it_about_leakeddatatitle2(inputs)
	if (locale === "hu") return hu_about_leakeddatatitle2(inputs)
	if (locale === "nl") return nl_about_leakeddatatitle2(inputs)
	if (locale === "no") return no_about_leakeddatatitle2(inputs)
	if (locale === "pl") return pl_about_leakeddatatitle2(inputs)
	if (locale === "pt-BR") return pt_br2_about_leakeddatatitle2(inputs)
	if (locale === "pt") return pt_about_leakeddatatitle2(inputs)
	if (locale === "ro") return ro_about_leakeddatatitle2(inputs)
	if (locale === "fi") return fi_about_leakeddatatitle2(inputs)
	if (locale === "sv") return sv_about_leakeddatatitle2(inputs)
	if (locale === "vi") return vi_about_leakeddatatitle2(inputs)
	if (locale === "tr") return tr_about_leakeddatatitle2(inputs)
	if (locale === "cs") return cs_about_leakeddatatitle2(inputs)
	if (locale === "bg") return bg_about_leakeddatatitle2(inputs)
	if (locale === "ru") return ru_about_leakeddatatitle2(inputs)
	if (locale === "uk") return uk_about_leakeddatatitle2(inputs)
	if (locale === "ar") return ar_about_leakeddatatitle2(inputs)
	if (locale === "hi") return hi_about_leakeddatatitle2(inputs)
	if (locale === "th") return th_about_leakeddatatitle2(inputs)
	if (locale === "ja") return ja_about_leakeddatatitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_about_leakeddatatitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_leakeddatatitle2(inputs)
	return ko_about_leakeddatatitle2(inputs)
});
export { about_leakeddatatitle2 as "about.leakedDataTitle" }